/**
 * Get the backend API base URL.
 * - REACT_APP_BACKEND_URL défini au build (dev/preview, ou backend sur un autre domaine) → URL absolue.
 * - Sinon (production Docker/VPS : Nginx sert le frontend et proxifie /api) → même origine (URL relative).
 * Aucun domaine codé en dur.
 */
const configured = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');

export const getBackendUrl = () => configured;
export const getApiUrl = () => `${getBackendUrl()}/api`;

/**
 * Get WebSocket URL — always needs an absolute URL.
 */
export const getWsUrl = () => {
  const backend = getBackendUrl();
  if (backend) {
    return backend.replace('https://', 'wss://').replace('http://', 'ws://');
  }
  // Same origin: build from current window location
  if (typeof window !== 'undefined') {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}`;
  }
  return '';
};
